import PopupBanner from './components/PopupBanner';
import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import BrandSection from './components/BrandSection';
import EnvironmentSection from './components/EnvironmentSection';
import PremiumSection from './components/PremiumSection';
import ArchitectureSection from './components/ArchitectureSection';
import CommunitySection from './components/CommunitySection';
import UnitSection from './components/UnitSection';
import InterestSection from './components/InterestSection';
import LocationSection from './components/LocationSection';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MobileActionBar from '@/components/feature/MobileActionBar';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <PopupBanner />
      <Navbar />
      <main>
        <HeroSection />
        <OverviewSection />
        <BrandSection />
        <EnvironmentSection />
        <PremiumSection />
        <ArchitectureSection />
        <CommunitySection />
        <UnitSection />
        <InterestSection />
        <LocationSection />
      </main>
      <Footer />
      <MobileActionBar />
    </div>
  );
}